var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../axios';
import { getActionStruct, getUniqCombosAndDraws } from '../../helpers';
import { getSizingsData } from '../../../../helpers/helpers';
import { setIsSelectedStack, setRequestForMultiStack } from '../../viewer';
import { history } from '../../../../_history';
export var fetchPositionsReportData = createAsyncThunk('reports/fetchPositionsReportData', function (_a, _b) {
    var query = _a.query;
    var rejectWithValue = _b.rejectWithValue, getState = _b.getState, dispatch = _b.dispatch;
    return __awaiter(void 0, void 0, void 0, function () {
        var url, threshold_1, spotId, _c, multiStacks, isStackSelected, requestParams, data, strategies, players, positionsFilter_1, cachePositions, filteredData, positionsRenderData, isReportNotAvailable, positionsSizings, _d, positionsCombos, positionsDraws, positionsData, error_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    dispatch(setRequestForMultiStack(true));
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    url = 'get_strategies_for_players';
                    threshold_1 = getState().preferences.dataNew.common.matrix.threshold;
                    spotId = getState().view.spotId;
                    _c = getState().view, multiStacks = _c.multiStacks, isStackSelected = _c.isStackSelected;
                    requestParams = { query: query, spotId: spotId };
                    return [4 /*yield*/, api.post(url, JSON.stringify(requestParams), {
                            'Content-Type': 'application/json',
                        })];
                case 2:
                    data = (_e.sent()).data;
                    history.push("?id=".concat(spotId, "&q=").concat(query, "#reports-positions"));
                    strategies = data.strategies;
                    players = data.players;
                    positionsFilter_1 = isStackSelected ? multiStacks : players;
                    cachePositions = strategies.map(function (item) { return getActionStruct(item, threshold_1); });
                    filteredData = cachePositions.filter(function (position) { return positionsFilter_1.includes(position[0].position); });
                    positionsRenderData = filteredData.length === 0 ? cachePositions : filteredData;
                    isReportNotAvailable = cachePositions.length === 0;
                    if (filteredData.length === 0) {
                        dispatch(setIsSelectedStack(false));
                    }
                    positionsSizings = strategies.reduce(function (acc, current) {
                        acc[current.player] = getSizingsData(current.trace, true);
                        return acc;
                    }, {});
                    _d = getUniqCombosAndDraws(strategies, threshold_1), positionsCombos = _d[0], positionsDraws = _d[1];
                    positionsData = {
                        cachePositions: cachePositions,
                        positionsRenderData: positionsRenderData,
                        positionsSizings: positionsSizings,
                        positionsCombos: positionsCombos,
                        positionsDraws: positionsDraws,
                        isReportNotAvailable: isReportNotAvailable,
                        positionStrategies: strategies,
                        positions: players,
                    };
                    dispatch(setRequestForMultiStack(false));
                    return [2 /*return*/, positionsData];
                case 3:
                    error_1 = _e.sent();
                    dispatch(setRequestForMultiStack(false));
                    // @ts-ignore
                    return [2 /*return*/, rejectWithValue(error_1.response.data)];
                case 4: return [2 /*return*/];
            }
        });
    });
});
